module.exports = __webpack_public_path__ + "media/images/icon/icons8-Login Rounded Down-ccc196999da6c29c35aa3fc99b2893a9.png";